import { useFragment } from 'react-relay';
import { baseDataEquityFragment } from './BaseDataEquity.relay';
import type { BaseDataEquityPropsType } from './types';

const BaseDataEquity: React.FC<BaseDataEquityPropsType> = (props: BaseDataEquityPropsType) => {
  const content = useFragment(baseDataEquityFragment, props.content);

  const { currency, value, text, datetext, date } = content;

  return (
    <div>
      <div className="flex gap-2 items-baseline-last text-accent font-heading pt-4 desktop:pt-0">
        <span className="text-xl">{currency}</span>
        <span className="text-4xl">{value}</span>
      </div>

      <div>
        <p className="m-0 p-0 text-2xl font-heading text-accent">{text}</p>
        <p className="m-0 p-0 text-sm">{`${datetext} ${date}`}</p>
      </div>
    </div>
  );
};

export { BaseDataEquity };
